import { skipToken } from '@reduxjs/toolkit/dist/query/react';
import { Footer } from './components/footer/Footer';
import { Header } from './components/header/Header';
import { QualificationFormDrawer } from './components/qualification-form-drawer/QualificationFormDrawer';
import { SnackbarStack } from './components/snackbar-stack/SnackbarStack';
import { RouteNavigation } from './routes';
import { useQualificationByEmailQuery } from './store/features/qualification/qualificationSlice';
import { initialSiteSettingState, useFetchSiteSettingsQuery } from './store/features/site-setting/siteSettingSlice';
import { useGetProfileQuery, useSignInUserWithTokenQuery } from './store/features/user/userSlice';
import { getGuestUserEmail } from './utils/qualification';
import { getTokenFromStorage } from './utils/token';
import { Banner } from './components/banner/Banner';
import { APP_URLS } from './routes/urls';

function App() {
  /**
   * Init app and fetch menus and site settings
   */
  const { isFetching, data = initialSiteSettingState } = useFetchSiteSettingsQuery();

  /**
   * Signing user in if we have token in local storage
   */
  const token = getTokenFromStorage();
  const { isSuccess, data: userData } = useSignInUserWithTokenQuery(token ?? skipToken);
  useGetProfileQuery(
    isSuccess && userData
      ? {
          slug: userData.slug,
          userId: userData.id.toString(),
        }
      : skipToken
  );

  /**
   * Getting guest user qualification if we have email on local storage
   */
  const email = getGuestUserEmail();
  useQualificationByEmailQuery(email ?? skipToken);

  return (
    <div className="App">
      <Banner
        message="IMPORTANT UPDATE: SEE Result 2079 is out."
        linkLabel="Check your result"
        link={APP_URLS.see2079Result}
      />
      <QualificationFormDrawer />
      <SnackbarStack />
      <Header menus={data.menus.Header} isLoading={isFetching} />
      <RouteNavigation />
      <Footer menus={data.menus.Footer} isLoading={isFetching} socialLinks={data.siteSetting.social_links} />
    </div>
  );
}

export default App;
